import React, {useState, useEffect, useCallback} from "react"
import MoreDropdown, {DropAction} from "../../buttons/moreDropdown/MoreDropdown"
import * as Order from "../../../dtos/orderResponse"
import MoneyOffIcon from "@mui/icons-material/MoneyOff"
import CancelIcon from "@mui/icons-material/Cancel"
import ReplaceIcon from "@mui/icons-material/Autorenew"
import ReceiptIcon from "@mui/icons-material/Receipt"
import CreditIcon from "@mui/icons-material/CreditCard"
import AgentVoyagerIcon from "@mui/icons-material/LinearScale"
import MailOutlineIcon from "@mui/icons-material/MailOutline"
//import {Cancel} from "./Cancel"
//import {Refund} from "./Refund"
import {RefundInfo} from "../../../dtos/refundInfo"
import {PaymentHistory} from "../../../services/order/paymentHistory"
import {OrderCredits} from "../../../services/order/CreditDetails"
//import {Replace} from "./Replace"
// import {Credit} from "./Credit"
// import {VatInvoice} from "./VatInvoice"
// import {ResendConfirmationEmail} from "./ResendConfirmationEmail"
import {postActionLog, ButtonActionTypes} from "../../../services/order/TrackOrderActions"
import {getCaseId} from "../../../utils/UrlParser"
import {Event} from "../../../dtos/eventResponse"
import {OrderActionTrigger, VatInvoice, ResendConfirmationEmail} from "@commercehub/order"
import {CREDIT_DISABLED_TOOLTIP} from "../../../utils/paymentCreditRestrictions"
import OrderService from "../../../services/order/OrderService"
const caseId = getCaseId()
const svc = new OrderService()
interface OrderActionProps {
	updateOrder: () => void
	refInfo: RefundInfo
	customerId: string
	order: Order.Order
	finHist?: PaymentHistory
	isFullyPaidWithMC: boolean
	paymentFullySuccessful: boolean
	orderCredits: OrderCredits | null
	orderIsReleasedToFulfillment: boolean
	eventHist: Event[]
	isVCSAgent: boolean
	isVCSOrder: boolean
	isPayOnBillingAccountOrder: boolean
	isCompanyCardOrder: boolean
}

export function OrderActions(props: OrderActionProps) {
	const [disabledReplacement, setDisabledReplacement] = useState(false)
	const [issuableAmountsForMC, setIssuableAmountsForMC] = useState<any>(null)
	const cancelIcon = () => {
		return <CancelIcon style={{paddingRight: "9px"}} /> //FIXME this makes the icon look a little nicer, but the padding should actually be managed back in the MoreDropdown
	}
	const refundIcon = () => {
		return <MoneyOffIcon style={{paddingRight: "9px"}} /> //FIXME this makes the icon look a little nicer, but the padding should actually be managed back in the MoreDropdown
	}
	const replaceIcon = () => {
		return <ReplaceIcon style={{paddingRight: "9px"}} /> //FIXME this makes the icon look a little nicer, but the padding should actually be managed back in the MoreDropdown
	}
	const receiptIcon = () => {
		return <ReceiptIcon style={{paddingRight: "9px"}} />
	}
	const creditIcon = () => {
		return <CreditIcon style={{paddingRight: "9px"}} />
	}
	const confirmationEmailIcon = () => {
		return <MailOutlineIcon style={{paddingRight: "9px"}} />
	}

	const agentVoyagerIcon = () => {
		return <AgentVoyagerIcon style={{paddingRight: "9px"}} />
	}

	// function isTerminalState(): boolean {
	// 	return ["Cancelled", "CancelRequested", "Completed", "Shipped", "Failed_order"].includes(
	// 		props.order.orderData.state
	// 	)
	// 		? true
	// 		: false
	// }

	function containsNonCancellableItem(): boolean {
		return props.order.orderData.lineItems.reduce(
			(accumulator, currentValue) => accumulator || currentValue.isCancellable === false,
			false
		)
	}

	/**
	 * If any of items replacement fields are disabled, replacement for the order will be disabled
	 */

	const allItemsReplacable = useCallback(() => {
		function postOrderReplacementOverride(): boolean {
			const disableReplacement = props.order.orderData.lineItems.reduce((accumulator, current) => {
				return (
					accumulator ||
					(current.customOrderData &&
					current.customOrderData.order &&
					current.customOrderData.order.postOrderActionOverrides &&
					current.customOrderData.order.postOrderActionOverrides.replacement
						? current.customOrderData.order.postOrderActionOverrides.replacement.disabled
						: false)
				)
			}, false)
			return disableReplacement
		}
		return postOrderReplacementOverride()
	}, [props.order.orderData.lineItems])

	function getReplacementHint() {
		if (props.order.isLegacy) {
			return "This is a legacy order, replacements are not allowed."
		} else if (!props.orderIsReleasedToFulfillment) {
			return "Replacements are not allowed on this order where a payment has not been successfully processed. Please check payment status."
		} else if (allItemsReplacable())
			return "Replacements are not allowed on this order; one or many products are temporarily unavailable."
		return ""
	}
	useEffect(() => {
		setDisabledReplacement(!props.orderIsReleasedToFulfillment || allItemsReplacable)
	}, [props.orderIsReleasedToFulfillment, allItemsReplacable])
	useEffect(() => {
		const getIssuableAmountsForMC = async (orderNumber: string) => {
			const issuableAmountsForMC = await svc.getIssuableAmountsForMC(orderNumber)
			setIssuableAmountsForMC(issuableAmountsForMC)
		}
		getIssuableAmountsForMC(props.order.orderNumber)
	}, [props.order.orderNumber])
	const shouldNotRefund = () => {
		return (
			(props.isVCSOrder && (!props.isVCSAgent || props.isPayOnBillingAccountOrder)) ||
			props.order.isLegacy ||
			(props.refInfo &&
				props.refInfo.totalRemaining &&
				props.refInfo.totalRemaining.amountInCents &&
				props.refInfo.totalRemaining.amountInCents === 0) ||
			!props.paymentFullySuccessful ||
			(props.order.orderData.payments != null &&
				props.order.orderData.payments.length > 0 &&
				((props.order.orderData.payments[0].paymentMethod || "").toLowerCase() === "multibanco" ||
					props.isFullyPaidWithMC))
		)
	}

	const logActionToSnowflake = (action: string) => {
		postActionLog(
			{
				event: action,
				actionMetaData: {
					orderNumber: props.order.orderNumber,
				},
			},
			caseId
		)
	}

	const options: Array<DropAction> = [
		{
			title: "Cancel Order",
			exe: cancelOrder,
			icon: cancelIcon,
			disabled:
				(props.isVCSOrder && !props.isVCSAgent) ||
				props.order.isLegacy ||
				containsNonCancellableItem(),
		},
		{title: "Refund Order", exe: refundOrder, icon: refundIcon, disabled: shouldNotRefund()},
		{
			title: "Credit Order",
			exe: creditOrder,
			trackToolTipClick: () => {
				logActionToSnowflake(ButtonActionTypes.HoverDisabledCreditOrderToolTip)
			},
			icon: creditIcon,
			disabled:
				(props.isVCSOrder &&
					(!props.isVCSAgent || props.isPayOnBillingAccountOrder || props.isCompanyCardOrder)) ||
				props.order.orderData.orderPlacedAnonymously ||
				(props.orderCredits?.totalCreditsIssued?.amountCents === 0 &&
					issuableAmountsForMC?.amountInMinorUnits === 0),
			hint:
				props.orderCredits?.totalCreditsIssued?.amountCents === 0 &&
				issuableAmountsForMC?.amountInMinorUnits === 0
					? CREDIT_DISABLED_TOOLTIP
					: undefined,
		},
		{
			title: "Replace Order",
			exe: replaceOrder,
			icon: replaceIcon,
			disabled:
				(props.isVCSOrder && !props.isVCSAgent) || props.order.isLegacy || disabledReplacement,
			hint: getReplacementHint(),
		},
		{
			title: "Download VAT",
			exe: downloadVat,
			icon: receiptIcon,
			disabled: props.isVCSOrder && !props.isVCSAgent,
		},
		{
			title: "Resend Confirmation Email",
			exe: resendConfirmationEmail,
			icon: confirmationEmailIcon,
			disabled: shouldDisableResendConfirmationEmail(),
		},
		{
			title: "Order Voyager",
			exe: openAgentVoyager,
			icon: agentVoyagerIcon,
		},
	]

	// Cancel Actions
	const [openCancel, setOpenCancel] = useState(false)

	function cancelOrder() {
		logActionToSnowflake(ButtonActionTypes.ClickCancelOrderButton)
		setOpenCancel(true)
	}
	function closeCancel() {
		setOpenCancel(false)
	}

	// Refund Actions
	const [openRefund, setRefundOpen] = useState(false)
	function refundOrder() {
		logActionToSnowflake(ButtonActionTypes.ClickRefundOrderButton)
		setRefundOpen(true)
	}

	function closeRefund() {
		setRefundOpen(false)
	}

	// Credit Actions
	const [openCredit, setCreditOpen] = useState(false)
	function creditOrder() {
		logActionToSnowflake(ButtonActionTypes.ClickCreditOrderButton)
		setCreditOpen(true)
	}
	function closeCredit() {
		setCreditOpen(false)
	}

	// VAT Invoice Action
	const [openVat, setVatOpen] = useState(false)
	function downloadVat() {
		setVatOpen(true)
	}
	function closeVat() {
		setVatOpen(false)
	}

	// Replace Actions
	const [openReplace, setReplaceOpen] = useState(false)
	function replaceOrder() {
		logActionToSnowflake(ButtonActionTypes.ClickReplaceOrderButton)
		setReplaceOpen(true)
	}
	function closeReplace() {
		setReplaceOpen(false)
	}

	function openAgentVoyager() {
		logActionToSnowflake(ButtonActionTypes.ClickOrderVoyagerButton)
		let win = window.open(
			`${process.env.REACT_APP_AGENT_VOYAGER}/agentVoyager/${props.order.orderNumber}`,
			"_blank"
		)
		if (win) win.focus()
	}

	// Resend Confirmation Email Action
	const [openResendConfirmationEmail, setResendConfirmationEmailOpen] = useState(false)
	function resendConfirmationEmail() {
		setResendConfirmationEmailOpen(true)
	}
	function closeResendConfirmationEmail() {
		setResendConfirmationEmailOpen(false)
	}

	function getOrderReadyToReleaseEventId() {
		const orderReadyToReleaseEvents = props.eventHist.filter(
			(event) => event.type === "ORDER_READY_TO_RELEASE"
		)
		if (orderReadyToReleaseEvents.length > 0 && orderReadyToReleaseEvents[0].id) {
			return orderReadyToReleaseEvents[0].id
		}
		return ""
	}

	function shouldDisableResendConfirmationEmail() {
		//Resend confirmation email is disabled in these cases
		//1- If it's a VCS order and the agent doesn't have access to VCS orders
		if (props.isVCSOrder && !props.isVCSAgent) {
			return true
		}
		//2- It's a Digital order
		if (props.order.orderData.tenantId.includes("DIGI")) {
			return true
		}
		//3- If we don't find ORDER_READY_TO_RELEASE event
		if (getOrderReadyToReleaseEventId() === "") {
			return true
		}
		//4- If all items are cancelled
		const allItemsCancelled =
			props.order.orderData.lineItems.filter(
				(item) =>
					item.states.filter(
						(itemState) =>
							itemState.state === "CancelSuccess" || itemState.state === "CancelRequested"
					).length > 0
			).length === props.order.orderData.lineItems.length
		if (allItemsCancelled) {
			return true
		}
		// If all deliverable lineItems without active holds have arrival dates, we can resend the confirmation email
		// it's ok if non-deliverable lineItems are without arrival dates,
		const deliverableItemsWithoutActiveHoldsWithoutArrivalDate =
			props.order.orderData.lineItems.filter(
				(item) =>
					item.isDeliverable &&
					!item.hasActiveHold &&
					(!item.promisedArrivalDate || item.promisedArrivalDate.toString() === "")
			)
		if (deliverableItemsWithoutActiveHoldsWithoutArrivalDate.length > 0) {
			return true
		}
		return false
	}

	return (
		<div>
			<MoreDropdown options={options} />
			{/* <Cancel
				isOpen={openCancel}
				close={closeCancel}
				customerId={props.customerId}
				order={props.order}
				reloadParent={props.updateOrder}
			/> */}
			<OrderActionTrigger
				type="cancel-order"
				isOpen={openCancel}
				onOpenChange={closeCancel}
				onComplete={props.updateOrder}
				orderId={props.order.orderNumber}
				orderData={props.order.orderData as any}
			/>

			{/* <Refund
				open={openRefund}
				close={closeRefund}
				order={props.order}
				reloadParent={props.updateOrder}
				finHist={props.finHist}
				isTerminalState={isTerminalState()}
				orderCredits={props.orderCredits}
				eventHist={props.eventHist}
				logOverPaymentConfirmYesButton={logActionToSnowflake}
			/> */}
			<OrderActionTrigger
				type="refund-order"
				isOpen={openRefund}
				onOpenChange={closeRefund}
				onComplete={props.updateOrder}
				orderId={props.order.orderNumber}
				orderData={props.order.orderData as any}
			/>
			{/* <Credit
				open={openCredit}
				close={closeCredit}
				order={props.order}
				reloadParent={props.updateOrder}
				finHist={props.finHist}
				orderCredits={props.orderCredits}
				eventHist={props.eventHist}
				logOverPaymentConfirmYesButton={logActionToSnowflake}
			/> */}
			<OrderActionTrigger
				type="credit-order"
				isOpen={openCredit}
				onOpenChange={closeCredit}
				onComplete={props.updateOrder}
				orderId={props.order.orderNumber}
				orderData={props.order.orderData as any}
			/>
			<OrderActionTrigger
				type="replace-order"
				isOpen={openReplace}
				onOpenChange={closeReplace}
				onComplete={props.updateOrder}
				orderId={props.order.orderNumber}
				orderData={props.order.orderData as any}
			/>
			{/* <Replace
				open={openReplace}
				close={closeReplace}
				customerId={props.customerId}
				order={props.order}
				reloadParent={props.updateOrder}
				finHist={props.finHist}
				orderCredits={props.orderCredits}
				eventHist={props.eventHist}
			/> */}

			{/* <VatInvoice
				open={openVat}
				close={closeVat}
				customerId={props.customerId}
				order={props.order}
			/> */}
			<VatInvoice
				isOpen={openVat}
				onOpenChange={closeVat}
				customerId={props.customerId}
				orderNumber={props.order.orderNumber}
			/>
			{/* <ResendConfirmationEmail
				open={openResendConfirmationEmail}
				close={closeResendConfirmationEmail}
				orderNumber={props.order.orderNumber}
				eventId={getOrderReadyToReleaseEventId()}
			/> */}
		</div>
	)
}
